import getQueryNames from "@irati/utils/services/apollo/helpers/getQueryNames"
import gql from "graphql-tag"
import ScheduledGroupCelebrationFragment from "../fragments/ScheduledGroupCelebration"
const mutation = gql`
  mutation UpdateScheduledGroupCelebrationMessage($groupCelebrationID: ID!, $messageId: ID!, $message: String!) {
    updateGroupCelebrationMessage(groupCelebrationID: $groupCelebrationID, messageId: $messageId, message: $message) {
      ...ScheduledGroupCelebration
    }
  }
  ${ScheduledGroupCelebrationFragment}
`
export const updateGroupCelebrationMessageMutationKey = getQueryNames(mutation)[0]
export default mutation
